// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"ec8543a99017a8f02d01","293":"de026aab46cc5cdec6d9","522":"54f40d40655745b40d85"}[chunkId] + ".js";
};